<template>
  <section class="panel">
    <nav-bar :name="'PAINEL ADMINISTRADOR'"></nav-bar>

    <div class="body">
      <img src="../assets/images/logos/Logo.png">

      <div class="infos">
        <div class="left">
          <h3>Olá, {{ currentUser.custom.displayName }}</h3>
          <p>Você está vendo os resultados de {{ selectedCity.cityName }}</p>

          <dropdown :class-name="'dropdown-one'" :close-on-click="true">
            <template slot="btn">Clique aqui para ver outras permissões</template>
            <template slot="body">
              <dropdown :trigger="'hover'" :role="'sublist'" :close-on-click="true" :class-name="'dropdown-two'" :align="'right'" v-for="(permission, index) in permissions" :key="index">
                <template slot="btn">{{ index }}</template>
                <template slot="body">
                  <p v-for="city in permission" :key="city.cityName" @click="selectCity(city)">{{ city.cityName }}</p>
                </template>
              </dropdown>
            </template>
          </dropdown>
        </div>

        <div class="right">
          <date-picker v-model="picker" :clearable="false" type="date" :format="'DD/MM/YYYY'" range @change="getMessages()" placeholder="Select date range">
          </date-picker>
        </div>
      </div>

      <div class="counters-display">
        <div class="box participations">
          <div class="numbers">
            <h1>{{ city.problemsCount + city.solutionsCount }}</h1>
            <p>Participações</p>
            <hr>
          </div>
        </div>

        <div class="box problems">
          <div class="numbers">
            <h1>{{ city.problemsCount ? city.problemsCount : 0 }}</h1>
            <p>Problemas</p>
            <hr>
          </div>
        </div>

        <div class="box sugestions">
          <div class="numbers">
            <h1>{{ city.solutionsCount ? city.solutionsCount : 0 }}</h1>
            <p>Sugestões</p>
            <hr>
          </div>
        </div>
      </div>

      <div class="charts">
        <div class="chart pie">
          <canvas id="pieChart" width="100%" height="100%"></canvas>
          <div class="regions">
            <div class="region" v-for="region in regions.regions" :key="region.name">
              <div class="left">
                <div class="block" :style="'background-color: ' + region.color"> </div>
                <h3>Região {{ region.name }}</h3>
              </div>
              <div class="right">
                {{ ((100*region.count)/regions.total).toFixed(1) }}%
              </div>
            </div>
          </div>
        </div>
        <div class="chart bar">
          <canvas id="barChart" width="100%" height="100%"></canvas>
        </div>
      </div>

      <div class="select-theme">
        <div class="left">
          <dropdown :class-name="'dropdown-one'" :close-on-click="true">
            <template slot="btn">{{ filterTheme ? `Filtrar temas: ${filterTheme}` : 'Filtrar temas'}}</template>
            <template slot="body">
              <p @click="selectTheme('')" class="remove-filter" v-if="filterTheme">Remover filtro</p>
              <p v-for="theme in themes" :key="theme" @click="selectTheme(theme)">{{ theme }}</p>
            </template>
          </dropdown>

          <dropdown :class-name="'dropdown-one'" :close-on-click="true">
            <template slot="btn">{{ filterRegion ? `Filtrar regiões: ${filterRegion}` : 'Filtrar regiões'}}</template>
            <template slot="body">
              <p @click="selectRegion('')" class="remove-filter" v-if="filterRegion">Remover filtro</p>
              <p v-for="(region, index) in regionsList" :key="index" @click="selectRegion(index)">{{ index }}</p>
            </template>
          </dropdown>
        </div>
      </div>

      <div class="list">
        <vue-table-dynamic :params="params" @row-click="clickRow"></vue-table-dynamic>
      </div>

      <download-csv :data="csv" class="export-csv" name="lista-de-conversoes.csv">
        <p>Exportar CSV</p>
      </download-csv>
    </div>

    <transition name="fade">
      <inspect-lead></inspect-lead>
    </transition>
    <bottom-bar></bottom-bar>
  </section>
</template>
<style lang="scss" scoped>
  .panel {
    .body {
      width: 80%;
      margin: auto;
      margin-top: 100px;

      img {
        display: block;
        margin: auto;
        max-width: 300px;
        width: 100%;
        margin-bottom: 100px;
      }

      .infos {
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
      }

      .counters-display {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-evenly;
        margin-top: 50px;

        .box {
          box-shadow: 0 6px 4px 0 rgba(0,0,0,0.25);
          width: 28%;
          height: 70px;
          padding-top: 25px;
          text-align: center;
          background-color: #fff;
          border-radius: 10px;

          @media (max-width: 1024px) {
            width: 100%;
            margin-bottom: 40px;
            display: block;
          }

          &.participations {
            p {
              background-color: #4D63FF;
            }
          }

          &.problems {
            p {
              background-color: #FF5D55;
            }
          }

          &.sugestions {
            p {
              background-color: #81E8AA;
            }
          }

          .numbers {
            display: flex;
            flex-direction: column;
            justify-content: space-evenly;
            height: 100%;

            h1 {
              margin: 0;
              font-size: 30px
            }
          }

          p {
            width: 90%;
            border: none;
            margin-bottom: -15px!important;
            color: #fff;
            bottom: 0;
            font-size: 1.3em;
            margin-left: 5%!important;
            border-radius: 10px;
            padding-bottom: 5px;
          }
        }
      }

      .charts {
        // display: flex;
        // flex-wrap: wrap;
        margin-top: 100px;
        // justify-content: space-between;

        .chart {
          width: 45%;
          box-shadow: 0 6px 4px 0 rgba(0,0,0,0.25);
          border-radius: 10px;
          background-color: #fff;
          padding: 20px;

          @media (max-width: 1024px) {
            width: 90%!important;

            &.pie {
              width: 100%;
              margin-bottom: 50px;
              display: block!important;

              #pieChart {
                width: 250px!important;
                height: 250px!important;
              }

              .regions {
                padding: 0!important;
              }
            }

            &.bar {
              #barChart {
                width: 250px!important;
                height: 250px!important;
                margin-top: 20px!important;
              }
            }
          }

          &.bar {
            display: flex;
            width: 100%;
            max-width: 1000px;
            margin: auto;
            height: 380px;

            #barChart {
              height: 330px!important;
              margin-top: 20px!important;
            }
          }

          &.pie {
            display: flex;
            max-width: 1000px;
            margin: auto;
            justify-content: space-around;
            margin-bottom: 30px;

            @media (min-width: 1025px) {
              width: 100%;

              #pieChart {
                width: 350px!important;
                height: 350px!important;
              }
            }

            .regions {
              padding: 30px;

              .region {
                display: flex;
                justify-content: space-between;
                margin-top: 10px;

                .left {
                  display: flex;

                  h3 {
                    margin: 5px;
                    margin-left: 15px;
                    font-weight: 400;
                    margin-top: 10px;
                  }

                  .block {
                    width: 40px;
                    height: 40px;
                    border: 1px solid #ccc;
                    border-radius: 5px;
                  }
                }

                .right {
                  margin-top: 10px;
                }
              }
            }
          }
        }
      }

      .list {
        margin-bottom: 50px;
        cursor: pointer;
      }

      .export-csv {
        background-color: #08F;
        width: 120px;
        padding: 3px;
        text-align: center;
        color: #fff;
        border-radius: 5px;
        cursor: pointer;
        font-size: 12px;
        display: block;
        margin-left: auto;

        &:hover {
          background-color: rgb(0, 97, 182);
          transition: .3s;
        }
      }
    }
  }
</style>
<style lang="scss">
  .panel {
    .body {
      .infos {
        .left {
          .dropdown-one-bp__btn {
            background: transparent;
            border: 0;
            cursor: pointer;
          }

          .dropdown-one-bp__body {
            font-size: 18px;
            box-shadow: none;
            background-color: #C8C8C8;
            border-radius: 5px;
            min-width: 0!important;
            padding: 0px 5px 0px 0px;
          }

          .dropdown-two-bp__btn {
            padding: 5px;
            border-top-left-radius: 5px;
            border-bottom-left-radius: 5px;
            cursor: pointer;
          }

          .dropdown-two-bp__btn--active {
            background: #8E8E8E;
          }

          .dropdown-two-bp__body {
            background-color: #8E8E8E;
            font-size: 18px;
            border-top-right-radius: 5px;
            border-bottom-right-radius: 5px;
            border-bottom-left-radius: 5px;
            min-width: 0!important;
            box-shadow: none;

            p {
              margin: 5px;
              cursor: pointer;
            }
          }
        }
      }
    }
  }

  .select-theme {
    .left {
      margin-top: 100px;
      display: flex;
      margin-bottom: 30px;

      .dropdown-one-bp__btn {
        background: transparent;
        border: 0;
        cursor: pointer;
      }

      .dropdown-one-bp__body {
        font-size: 18px;
        box-shadow: none;
        background-color: #C8C8C8;
        border-radius: 5px;
        min-width: 0!important;
        padding: 0px 5px 0px 0px;
        cursor: pointer;
      }

      .dropdown-one-bp__btn {
        padding: 5px;
        border-radius: 5px;
        cursor: pointer;
      }

      .dropdown-one-bp__btn--active {
        background: #8E8E8E;
      }

      .dropdown-one-bp__body {
        font-size: 18px;
        border-top-right-radius: 5px;
        border-bottom-right-radius: 5px;
        border-bottom-left-radius: 5px;
        min-width: 0!important;
        box-shadow: none;

        p {
          margin: 5px;
          cursor: pointer;
        }
      }
    }
  }
</style>
<script>
import _ from 'lodash';
// eslint-disable-next-line
import Dropdown from 'bp-vuejs-dropdown';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import Chart from 'chart.js';
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import moment from 'moment';

export default {
  data() {
    return {
      currentUser: {
        main: {},
        custom: {
          can: {},
        },
      },
      regions: {
        total: 0,
        regions: [],
      },
      picker: [moment().hour(0).subtract(7, 'd').toDate(), moment().hour(23).toDate()],
      csv: [],
      messages: null,
      colors: ['#4D63FF', '#FF5D55', '#81E8AA', '#d0ff4d', '#9E00FF', '#ffc44d', '#8e4dff', '#de4dff'],
      permissions: null,
      selectedCity: null,
      themes: [],
      regionsList: [],
      filterTheme: '',
      filterRegion: '',
      city: {
        nome: '',
        cityName: '',
        neighborhood: [],
        microrregiao: {
          mesorregiao: {
            UF: {
              sigla: '',
            },
          },
        },
      },
      toParamsObj: [],
      params: {
        data: [
          ['Data', 'Nome', 'Email', 'Telefone', 'Bairro', 'Região', 'Tema', 'Conversões'],
        ],
        header: 'row',
        sort: [0, 3, 4, 5, 6],
        pagination: true,
        pageSize: 10,
        pageSizes: [10, 20, 50, 100],
      },
    };
  },

  components: {
    Dropdown,
    DatePicker,
  },

  created() {
    if (!sessionStorage.getItem('currentUser')) {
      this.$router.push({ name: 'Login Page' });
    } else {
      this.currentUser = JSON.parse(sessionStorage.getItem('currentUser'));

      this.selectedCity = this.currentUser.custom.can[0];

      this.permissions = _.groupBy(this.currentUser.custom.can, (s) => {
        return s.ufName;
      });

      this.getCity();
    }
  },

  methods: {
    selectCity(city) {
      this.selectedCity = city;
      this.getCity();
    },

    selectTheme(theme) {
      this.filterTheme = theme;
      this.getCity();
    },

    selectRegion(region) {
      this.filterRegion = region;
      this.getCity();
    },

    getCity() {
      this.db.collection('states').doc(this.selectedCity.uf).collection('cities').doc(this.selectedCity.city)
        .get()
        .then((query) => {
          this.city = query.data();

          this.themes = this.city.themes;

          this.regionsList = _.groupBy(this.city.neighborhood, (n) => {
            return n.region;
          });

          console.log(this.regionsList);

          console.log(this.city);

          this.getMessages();
        });
    },

    getMessages() {
      const dateOne = Number(moment(this.picker[0]).hour(0).format('X'));
      const dateTwo = Number(moment(this.picker[1]).hour(23).format('X'));

      if (this.filterTheme && !this.filterRegion) {
        console.log('com filtro');
        this.db.collection('states').doc(this.selectedCity.uf).collection('cities').doc(this.selectedCity.city)
          .collection('messages')
          .where('date', '>=', dateOne)
          .where('date', '<=', dateTwo)
          .where('theme', '==', this.filterTheme)
          .orderBy('date', 'desc')
          .get()
          .then((query) => {
            const messages = [];

            query.forEach((message) => {
              const d = message.data();

              messages.push({
                id: message.id,
                data: d,
              });

              this.csv.push({
                Nome: d.name,
                Email: d.email,
                Telefone: d.phone,
                Cidade: d.city,
                Estado: d.uf,
                Bairro: d.neighborhood.name,
                Regiao: d.neighborhood.region,
                Tema: d.theme,
                Titulo: d.title,
                Mensagem: d.message,
                Data: d.ddmmyyyy,
              });
            });


            this.displayList(messages);
            this.renderBarChart(messages);
            this.renderPieChart(messages);
          });
      } else if (this.filterRegion && !this.filterTheme) {
        console.log('com filtro de regiao');
        this.db.collection('states').doc(this.selectedCity.uf).collection('cities').doc(this.selectedCity.city)
          .collection('messages')
          .where('date', '>=', dateOne)
          .where('date', '<=', dateTwo)
          .where('neighborhood.region', '==', this.filterRegion)
          .orderBy('date', 'desc')
          .get()
          .then((query) => {
            const messages = [];

            query.forEach((message) => {
              const d = message.data();

              messages.push({
                id: message.id,
                data: d,
              });

              this.csv.push({
                Nome: d.name,
                Email: d.email,
                Telefone: d.phone,
                Cidade: d.city,
                Estado: d.uf,
                Bairro: d.neighborhood.name,
                Regiao: d.neighborhood.region,
                Tema: d.theme,
                Titulo: d.title,
                Mensagem: d.message,
                Data: d.ddmmyyyy,
              });
            });


            this.displayList(messages);
            this.renderBarChart(messages);
            this.renderPieChart(messages);
          });
      } else if (this.filterTheme && this.filterRegion) {
        this.db.collection('states').doc(this.selectedCity.uf).collection('cities').doc(this.selectedCity.city)
          .collection('messages')
          .where('date', '>=', dateOne)
          .where('date', '<=', dateTwo)
          .where('neighborhood.region', '==', this.filterRegion)
          .where('theme', '==', this.filterTheme)
          .orderBy('date', 'desc')
          .get()
          .then((query) => {
            const messages = [];

            query.forEach((message) => {
              const d = message.data();

              messages.push({
                id: message.id,
                data: d,
              });

              this.csv.push({
                Nome: d.name,
                Email: d.email,
                Telefone: d.phone,
                Cidade: d.city,
                Estado: d.uf,
                Bairro: d.neighborhood.name,
                Regiao: d.neighborhood.region,
                Tema: d.theme,
                Titulo: d.title,
                Mensagem: d.message,
                Data: d.ddmmyyyy,
              });
            });


            this.displayList(messages);
            this.renderBarChart(messages);
            this.renderPieChart(messages);
          });
      } else {
        this.db.collection('states').doc(this.selectedCity.uf).collection('cities').doc(this.selectedCity.city)
          .collection('messages')
          .where('date', '>=', dateOne)
          .where('date', '<=', dateTwo)
          .orderBy('date', 'desc')
          .get()
          .then((query) => {
            const messages = [];

            query.forEach((message) => {
              const d = message.data();

              messages.push({
                id: message.id,
                data: d,
              });

              this.csv.push({
                Nome: d.name,
                Email: d.email,
                Telefone: d.phone,
                Cidade: d.city,
                Estado: d.uf,
                Bairro: d.neighborhood.name,
                Regiao: d.neighborhood.region,
                Tema: d.theme,
                Titulo: d.title,
                Mensagem: d.message,
                Data: d.ddmmyyyy,
              });
            });


            this.displayList(messages);
            this.renderBarChart(messages);
            this.renderPieChart(messages);
          });
      }
    },

    displayList(messages) {
      this.params.data = [['Data', 'Nome', 'Email', 'Telefone', 'Bairro', 'Região', 'Tema', 'Conversões']];

      this.toParamsObj = _.groupBy(messages, (m) => {
        return m.data.email;
      });

      const toParams = Object.entries(this.toParamsObj);

      toParams.forEach((entry) => {
        const first = entry[1];
        const d = first[0].data;

        this.params.data.push([first[0].data.ddmmyyyy, d.name, d.email, d.phone, d.neighborhood.name, d.neighborhood.region, d.theme, first.length]);
      });
    },

    renderBarChart(messages) {
      const ctx = document.getElementById('barChart').getContext('2d');
      const dataValues = [];
      const labelsValues = [];

      const themeObj = _.groupBy(messages, (message) => {
        return message.data.theme;
      });

      const themes = Object.entries(themeObj);

      themes.forEach((theme) => {
        dataValues.push(theme[1].length);
        labelsValues.push(theme[0]);
      });

      // eslint-disable-next-line
      const myChart = new Chart(ctx, {
        type: 'horizontalBar',
        data: {
          labels: labelsValues,
          datasets: [{
            label: 'N° de envios',
            data: dataValues,
            backgroundColor: this.colors,
            borderWidth: 0,
            barThickness: 60,
          }],
        },
        plugins: [ChartDataLabels],
        options: {
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
            datalabels: {
              color: '#fff',
              font: {
                size: 16,
                weight: 'bold',
              },
            },
          },
          legend: {
            display: false,
          },
          scales: {
            yAxes: [{
              gridLines: {
                display: false,
              },
              ticks: {
                beginAtZero: true,
                stepSize: 10,
              },
            }],
            xAxes: [{
              gridLines: {
                display: false,
              },
              ticks: {
                beginAtZero: true,
                stepSize: 10,
                lineHeight: 1,
                display: false,
              },
            }],
          },
        },
      });
    },

    renderPieChart(messages) {
      const ctx = document.getElementById('pieChart').getContext('2d');
      this.regions.total = messages.length;
      this.regions.regions = [];
      const dataValues = [];
      const labelsValues = [];

      const regionsObj = _.groupBy(messages, (message) => {
        return message.data.neighborhood.region;
      });

      const regions = Object.entries(regionsObj);

      regions.forEach((region, index) => {
        this.regions.regions.push({
          name: region[0],
          count: region[1].length,
          color: this.colors[index],
        });

        dataValues.push(region[1].length);
        labelsValues.push(region[0]);
      });

      // eslint-disable-next-line
      const myChart = new Chart(ctx, {
        type: 'doughnut',
        data: {
          labels: labelsValues,
          datasets: [{
            label: '% por região',
            data: dataValues,
            backgroundColor: this.colors,
            borderWidth: 0,
          }],
        },
        plugins: [ChartDataLabels],
        options: {
          legend: {
            display: false,
          },
          cutoutPercentage: 80,
          plugins: {
            datalabels: {
              color: 'transparent',
              font: {
                size: 16,
              },
            },
          },
          scales: {
            yAxes: [{
              gridLines: {
                display: false,
              },
              ticks: {
                beginAtZero: true,
                stepSize: 10,
                display: false,
              },
            }],
            xAxes: [{
              gridLines: {
                display: false,
              },
              ticks: {
                beginAtZero: true,
                stepSize: 10,
                display: false,
              },
            }],
          },
        },
      });
    },

    clickRow(index, data) {
      this.bus.$emit('inspectLead', this.toParamsObj[data[2]]);
    },
  },
};
</script>
